import styled from "@emotion/styled";

export const StyledSpreadsheet = styled.div`
  padding: 1.5rem;
  .fm-loading {
    height: 80dvh;
  }
  .ant-segmented {
    background: var(--linear-bg);
    color: white;
  }

  .ant-table-row {
    cursor: pointer;
  }

  .ant-breadcrumb {
    .anticon {
      font-size: 24px;
      margin-right: 10px;
    }
    li {
      font-size: 24px;
      margin-left: 0px;
      cursor: pointer;
    }
    .ant-breadcrumb-separator {
      margin: 0px 20px;
    }
  }

  .fm-root-label {
    margin-bottom: 10px;
  }

  .fm-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
    margin-bottom: 10px;
  }

  .folder-item,
  .file-item {
    position: relative;
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 5px;
    .name {
      max-width: stretch;
      font-size: 16px;
    }
    .more-option {
      position: absolute;
      right: 0;
      top: 5px;
      font-size: 20px;
    }
    .workbook-count {
      font-size: 12px;
      color: #888;
      margin-top: 2px;
    }
  }
  .folder-item {
    .name {
      margin-top: -9px;
    }
  }

  .icons {
    gap: 10px;
    button {
      font-size: 20px;
    }
  }
`;
